'use client';

import { Search, X } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

export const SearchInput = ({
  value,
  onChange,
  onClear,
  placeholder,
  ref,
  filtersButton,
}: {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
  ref?: React.Ref<HTMLInputElement>;
  filtersButton?: React.ReactNode;
}) => {
  return (
    <div className='relative flex'>
      <Button
        type='submit'
        variant='ghost'
        size='icon'
        className='shrink-0 rounded-l-xl rounded-r-none border border-r-0 border-[#D1D1D1] hover:bg-brand-soft/25 focus-visible:ring-brand-green focus-visible:ring-offset-0'
      >
        <Search className='text-brand-green' size={20} />
      </Button>
      <Input
        ref={ref}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={cn(
          'border-[#D1D1D1] px-0.5 text-left placeholder:text-left focus-visible:ring-brand-green focus-visible:ring-offset-0',
          filtersButton
            ? 'rounded-none border-x-0'
            : 'rounded-l-none rounded-r-xl border-l-0',
          value && 'sm:pr-10',
        )}
      />
      {value && (
        <Button
          type='button'
          variant='transparent'
          size='icon-sm'
          className={cn(
            'absolute top-1/2 z-10 hidden -translate-y-1/2 hover:text-brand-dark sm:flex',
            filtersButton ? 'right-12' : 'right-2',
          )}
          onClick={onClear}
          aria-label='Clear search'
          tabIndex={0}
        >
          <X size={16} />
        </Button>
      )}
      {filtersButton && <div className='flex'>{filtersButton}</div>}
    </div>
  );
};
